import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import { Header, Dimmer } from 'semantic-ui-react'
import Icon from '../../elementals/icon'
import Button from '../../elementals/button'
import Text from '../../elementals/text'
import Modal from '../../overlays/modal'
import PhotoManagement from '../photoManagement'

const PhotoManagementModal = ({
  isOpen,
  photos,
  property,
  onConfirm,
  onModalClose,
  updatePhotos,
  loading,
  trigger,
  settings,
  maxFileSize,
  maxPhotosAllowed,
}) => {
  return (
    <Modal
      open={isOpen}
      size='large'
      closeIcon={false}
      data-elm-id='photo_management_modal'
      trigger={trigger}
    >
      <Header>
        <Header.Content>
          <Text weight='heavy' size='large'>
            <Icon name='image' iconStyle='solid' /> Manage Photos for{' '}
            {_.get(property, 'summary.street_address', '')}
          </Text>
          <Text className='u-mt-1' size='tiny'>
            {settings.hideUnusedPhotos
              ? 'Specify photos to show on the listing. Drag-and-drop to reorder.'
              : 'Specify photos to show on the current listing. Drag-and-drop to reorder, and/or remove.'}
          </Text>
        </Header.Content>
      </Header>
      <Modal.Content>
        <Dimmer.Dimmable dimmed blurring={loading}>
          <Dimmer inverted active={loading}>
            Uploading
          </Dimmer>
          <PhotoManagement
            photos={photos}
            property={property}
            updatePhotos={updatePhotos}
            settings={settings}
            maxFileSize={maxFileSize}
            maxPhotosAllowed={maxPhotosAllowed}
          />
        </Dimmer.Dimmable>
      </Modal.Content>
      <Modal.Actions>
        <Button role='secondary' elmId='on_modal_close' onClick={onModalClose}>
          Cancel
        </Button>
        <Button
          role='primary'
          elmId='on_modal_confirm'
          onClick={onConfirm}
          loading={loading}
          disabled={loading}
        >
          Save
        </Button>
      </Modal.Actions>
    </Modal>
  )
}

PhotoManagementModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onModalClose: PropTypes.func.isRequired,
  updatePhotos: PropTypes.func.isRequired,
  property: PropTypes.object,
  photos: PropTypes.array,
  loading: PropTypes.bool,
  trigger: PropTypes.any.isRequired,
  settings: PropTypes.object,
  maxFileSize: PropTypes.number,
  maxPhotosAllowed: PropTypes.number,
}

PhotoManagementModal.defaultProps = {
  property: {},
  photos: [],
  loading: false,
  settings: {},
}

export default PhotoManagementModal
